/// <reference types="google.accounts" />
import { useCallback, useEffect, useState } from "react";

import { getConfig } from "~/config";
import { useScript } from "./useScript";

const GOOGLE_GSI_URL = "https://accounts.google.com/gsi/client";
const CLIENT_ID = getConfig("GOOGLE_CLIENT_ID");

interface CredentialResponse {
  credential: string;
  select_by: string;
}

export const useGoogleOneTap = () => {
  const [scriptAttached, setScriptAttached] = useState<boolean>(false);
  const scriptStatus = useScript(GOOGLE_GSI_URL);
  const [credentialResponse, setCredentialResponse] =
    useState<CredentialResponse | null>(null);

  useEffect(() => {
    if (scriptStatus === "ready" && window.google && !scriptAttached) {
      google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: setCredentialResponse,
        auto_select: true,
        use_fedcm_for_prompt: true,
        cancel_on_tap_outside: false,
      });

      setScriptAttached(true);
    }
  }, [scriptStatus, scriptAttached]);

  const promptOneTap = useCallback(() => {
    if (!scriptAttached && !window.google) return;

    google.accounts.id.prompt((notification) => {
      // FIXME: Present alternative login if the user by accident clicks "cancel" or skips the moment
      // see: google.accounts.id.renderButton
      if (notification.isNotDisplayed()) {
        throw new Error(
          `[useGoogleOneTap]: ${notification.getNotDisplayedReason()}`
        );
      }
      if (notification.isSkippedMoment()) {
        throw new Error(
          `[useGoogleOneTap]: ${notification.getSkippedReason()}`
        );
      }
    });
  }, [scriptAttached]);

  return {
    promptOneTap,
    credentialResponse,
  };
};
